import { IEntitiesTreeItem } from "../../../../models/entity.interface";
import ManagementTree from "../../ManageTree/ManagementTree";

import TreeEntity from "./TreeEntity/TreeEntity";

type ManageEntitiesTreeProps = {
  data?: IEntitiesTreeItem[];
};

const ManageEntitiesTree = ({ data }: ManageEntitiesTreeProps) => {
  const rootNode = data && data.length ? data[0] : null;
  const maxAddEntitiesAllowed = rootNode?.maxEntitiesLevel ?? 0;

  const treeItemMapper = (item: IEntitiesTreeItem) => (
    <TreeEntity
      item={item}
      hideAdd={
        typeof item.levelInTree === "number"
          ? item.levelInTree >= maxAddEntitiesAllowed
          : true
      }
      hideEdit={item.id === rootNode?.id}
      hideDelete={item.id === rootNode?.id}
    />
  );

  return (
    <ManagementTree
      defaultExpandAll
      data={data}
      treeItemMapper={treeItemMapper}
    />
  );
};

export default ManageEntitiesTree;
